/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLocationModifiers200ResponseItemsInner
 */
export interface GetLocationModifiers200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GetLocationModifiers200ResponseItemsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocationModifiers200ResponseItemsInner
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetLocationModifiers200ResponseItemsInner
     */
    enabled: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetLocationModifiers200ResponseItemsInner
     */
    organizationEnabled: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof GetLocationModifiers200ResponseItemsInner
     */
    priceImpact?: number;
}

/**
 * Check if a given object implements the GetLocationModifiers200ResponseItemsInner interface.
 */
export function instanceOfGetLocationModifiers200ResponseItemsInner(value: object): value is GetLocationModifiers200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('organizationEnabled' in value) || value['organizationEnabled'] === undefined) return false;
    return true;
}

export function GetLocationModifiers200ResponseItemsInnerFromJSON(json: any): GetLocationModifiers200ResponseItemsInner {
    return GetLocationModifiers200ResponseItemsInnerFromJSONTyped(json, false);
}

export function GetLocationModifiers200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationModifiers200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'enabled': json['enabled'],
        'organizationEnabled': json['organizationEnabled'],
        'priceImpact': json['priceImpact'] == null ? undefined : json['priceImpact'],
    };
}

export function GetLocationModifiers200ResponseItemsInnerToJSON(json: any): GetLocationModifiers200ResponseItemsInner {
    return GetLocationModifiers200ResponseItemsInnerToJSONTyped(json, false);
}

export function GetLocationModifiers200ResponseItemsInnerToJSONTyped(value?: GetLocationModifiers200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'enabled': value['enabled'],
        'organizationEnabled': value['organizationEnabled'],
        'priceImpact': value['priceImpact'],
    };
}

